import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { getOrdersNew, getOrdersAdvanced, updateOrderList, updateOrderListSingle, getOrderSimple, setOrdersSearch, setOrdersFilter, resetFilter, resetSimplesearch, getOrderSorting, mustOrderUpdateDueToSocket } from '../../../actions/orders'
import { getOrderDataNew } from '../../../actions/assign'
import { triggerPopup, setInfoModal } from '../../../actions/backdrop'
import { isFilterChanged, getOrderFilterData } from '../../../utils/filter'
import { isEqual } from 'lodash'
// import VisibilitySensor from 'react-visibility-sensor'
import EventEmitter from '../../../utils/events'

// import styles
import './orderlist.scss'

// import components
import Header from '../../../shared/components/Header'
import SearchFilter from '../../../shared/components/Search/SearchFilter'

// import modals
import NewOrdersModal from '../../../shared/modals/NewOrdersModal'
import InfoModal from '../../../shared/modals/InfoModal'
import LoginAsModal from '../../../shared/modals/LoginAsModal'
import OverviewStatusSelection from '../../../shared/components/OverviewStatusSelection'
import OrderCapacityOverview from '../../../shared/overlays/OrderCapacityOverview'

// Utils
// import { isFilterChanged } from '../../../utils/filter'
import { hasSubscriptionPermission, hasAccess } from '../../../utils/auth'
import { translation } from '../../../utils/helpers'

import { openPopup, closePopup, openOverlay } from '../../../actions/common'

// List
import List from './List'

import Button from '../../../shared/elements/button'
import Icon from '../../../shared/elements/icon'
import { FilterIcons } from '../../../shared/elements/icons'

class OrderList extends Component {

  constructor (props) {
    super(props)
    this.state = {
      isLoading: true,
      orders: [],
      addPopupShow: false,
      infoModal: false,
      filterOpen: false,
      simplesearch: null,
      loginasmodal: false,
      loginasmodalData: {},
      openStartStopId: false,
      openAction: false,
      selectedItem: null,
      reloadAfterModalClose: false
    }
    this.quickSearch = this.quickSearch.bind(this)
    this.onSearchSubmit = this.onSearchSubmit.bind(this)
    this.headerButtonsRight = this.headerButtonsRight.bind(this)
    this.showAddPopup = this.showAddPopup.bind(this)
    this.handleRowUpdate = this.handleRowUpdate.bind(this)
    this.openFilter = this.openFilter.bind(this)
    this.handleLinkedOrders = this.handleLinkedOrders.bind(this)
    this.onStartAsShopLogin = this.onStartAsShopLogin.bind(this)
    this.closeLoginAs = this.closeLoginAs.bind(this)

    // Sockets
    this.updateFromOrderSocket = this.updateFromOrderSocket.bind(this)
    this.updateSingleOrder = this.updateSingleOrder.bind(this)
    this.updateOrderSteps = this.updateOrderSteps.bind(this)
    this.orderMovedUpdateOrderSteps = this.orderMovedUpdateOrderSteps.bind(this)
    this.updateOrderCreated = this.updateOrderCreated.bind(this)
    this.updateRemainingTime = this.updateRemainingTime.bind(this)

    this.filterstyle = this.filterstyle.bind(this)
  }

  componentDidMount () {
    this.checkOpenCapacityOverview()
    this.setBodyClass(false)
    EventEmitter.addListener('update_row-orderlist', this.handleRowUpdate, this)
    EventEmitter.addListener('updateorderlist', this.handleLinkedOrders, this)
    EventEmitter.addListener('ORDER_SOCKET', this.updateFromOrderSocket, this)
    EventEmitter.addListener('ORDER_TIMES', this.updateRemainingTime, this)
    this.setState({
      orders: [],
      isLoading: false,
      UserId: 0
    })

    var items = JSON.parse(window.localStorage.getItem('newOrdersFilter'))
    var newOrdersFilter = 0

    if (items && typeof items.push === 'function') {
      items.map(x => {
        if (x.userId === this.props.auth.user.UserId) {
          newOrdersFilter = x.filter
        }
      })
    }
    let filterData = getOrderFilterData(this.props)
    let refreshFilter = filterData.filter
    // let refreshFilter = this.props.filter

    // if page refresh (current filter reset not manually), take from local storage
    // movedOrders = true is default on orderlist
    // let source = null
    // if (isEqual(this.props.filter, this.props.initialFilter)) {
    //   source = 'filterOrderlist'
    //   if (hasAccess([4], this.props.auth.user.UserType)) {
    //     source = 'filterCustomer'
    //   } else if (hasAccess([6], this.props.auth.user.UserType)) {
    //     source = 'filterWP'
    //   }
    //   let storedFilter = JSON.parse(window.localStorage.getItem(source))
    //   if (storedFilter !== undefined) {
    //     refreshFilter = storedFilter
    //   }
    // }

    let filter = {
      ...refreshFilter,
      NewOrdersFilter: newOrdersFilter
    }
    // let simpleSearch = JSON.parse(window.localStorage.getItem('simpleSearch'))
    // let simpleSearch = filterData.simpleSearch
    // if (!simpleSearch || simpleSearch.value.length === 0) {
    if (!filterData.hasSimpleSearch) {
      setTimeout(() => {
        this.getOrders(filter)
      })
    }

    // Check if need to open capacity overview
    let location = this.props.router.location
    if (location.query.destination && location.query.destination === 'capacityoverview') {
      this.props.openOverlay('OrderCapacityOverview')
      this.props.router.replace({...location, query: {}})   // Reset query to only trigger once.
    }
  }

  componentWillUnmount () {
    this.setBodyClass(true)
    EventEmitter.removeListener('update_row-orderlist', this.handleRowUpdate)
    EventEmitter.removeListener('updateorderlist', this.handleLinkedOrders)
    EventEmitter.removeListener('ORDER_SOCKET', this.updateFromOrderSocket)
    EventEmitter.removeListener('ORDER_TIMES', this.updateRemainingTime)
  }

  checkOpenCapacityOverview () {
    let routeItems = window.LocalstorageStack.all()
    let index = routeItems.length - 3
    if (routeItems && routeItems.length > 3 && routeItems[index].pathname === 'OrderCapacityOverview') {
      this.props.openOverlay('OrderCapacityOverview')
    }
  }

  onStartAsShopLogin (data) {
    this.props.triggerPopup(true)
    this.setState({
      loginasmodal: true,
      loginasmodalData: data
    })
  }

  filterstyle (visible) {
    let hasFilterOpen = document.getElementsByClassName('filter__wrap clearfix open')[0]
    if (hasFilterOpen && window.innerWidth > 1000) {
      let filter = document.getElementsByClassName('left__wrap')[0]
      if (visible === false) {
        filter.style.position = 'fixed'
      } else if (visible === true) {
        filter.style.position = 'absolute'
      }
    }
  }

  setBodyClass (out) {
    setTimeout(() => {
      if (out) {
        document.getElementsByTagName('body')[0].className = document.getElementsByTagName('body')[0].className.replace('orderlist_body', '')
      } else {
        document.getElementsByTagName('body')[0].className = document.getElementsByTagName('body')[0].className + ' orderlist_body'
      }
    }, 0)
  }

  getAssignOrders (data) {
    // Find order ids
    let orderIds = []
    data[0].Steps.map((val) => {
      val.Orders.map((v) => {
        orderIds.push(v.Id)
      })
    })
    this.props.getOrderDataNew({
      OrderIds: orderIds,
      UserIds: this.props.activeEmployees
    })
  }

  updateFromOrderSocket (json) {
    switch (json.Type) {
      case 'ORDER_UPDATE':
        this.updateSingleOrder(json.Data)
        break
      case 'ORDER_CREATED':
        this.updateOrderCreated(json.Data, 500)
        break
      default:
        if (json.Type === 'ORDER_MOVED' && json.Data.MovedOrderIds !== undefined || json.Data.MovedOrderId !== undefined) {
          this.orderMovedUpdateOrderSteps(json.Data)
        } else {
          this.updateOrderSteps(json.Data)
        }
        break
    }
  }

  updateRemainingTime (json) {
    let steps = JSON.parse(JSON.stringify(this.props.orders))
    steps.map((step, key) => {
      if (step.Title === '1' || step.Title === '2' || step.Title === '3' || step.Title === '4' ||
        step.Title === '5' || step.Title === '6' || step.Title === '7') {
        step.Orders.map((order, orderKey) => {
          if (order.IsStarted) {
            json.Data.map((remainingTime, timeKey) => {
              if (order.Id === remainingTime.OrderId) {
                order.RemainingTimeDelay = remainingTime.Delay
                order.ColoredParts = remainingTime.ColoredParts
              }
            })
          }
        })
      }
    })
    this.props.updateOrderList(steps)
  }

  updateOrderCreated (data, delay) {
    const arrayObjectIndexOf = (myArray, searchTerm, property) => {
      for (let i = 0, len = myArray.length; i < len; i++) {
        if (myArray[i][property] === searchTerm) return i
      }
      return -1
    }
    setTimeout(() => {
      let filterSteps = [0, 1]
      let isUpdate = false
      if (data.data !== undefined && data.data.length !== undefined && data.data.length > 0) {
        if (data.data.some(x => x > 1)) {
          isUpdate = true
          filterSteps = data.data
        }
      }

      let filterData = getOrderFilterData(this.props)
      // let proces = {
      //   ...this.props.filter.process,
      //   Completed: false
      // }
      // let filter = {
      //   ...this.props.filter,
      //   steps: filterSteps,
      //   process: proces
      // }
      // filter.SimpleSearch = this.state.simplesearch === '' ? null : this.state.simplesearch

      let proces = {
        ...filterData.filter.process,
        Completed: false
      }
      let filter = {
        ...filterData.filter,
        steps: filterSteps,
        process: proces
      }
      filter.SimpleSearch = filterData.simpleSearch.value === '' ? null : filterData.simpleSearch.value

      // console.log('getOrdersNew in updateOrderCreated', filter, 'initial', this.props.initialFilter)
      this.props.getOrdersNew(filter).then((res) => {
        let orders = JSON.parse(JSON.stringify(this.props.orders))
        let steps = res.data[0].Steps
        if (data.IsReferredOut === true) {
          orders[6] = steps[6]
        } else if (!isUpdate) {
          let stepArray = [0, 1]
          for (let i = 0; i < stepArray.length; i++) {
            let x = arrayObjectIndexOf(orders, (stepArray[i] + ''), 'Title')
            let z = arrayObjectIndexOf(steps, (stepArray[i] + ''), 'Title')
            orders[x] = steps[z]
          }
        } else {
          for (let i = 0; i < filterSteps.length; i++) {
            let x = arrayObjectIndexOf(orders, filterSteps[i], 'StepId')
            let z = arrayObjectIndexOf(steps, filterSteps[i], 'StepId')
            orders[x] = steps[z]
          }
        }
        this.props.updateOrderList(orders)
      })
    }, delay)
  }

  updateSingleOrder (data) {
    // console.log('orderList ORDER_UPDATE updateSingleOrder', data)
    let getFromServer = data.IsUpdateRequired !== undefined && data.IsUpdateRequired === true
    let orders = JSON.parse(JSON.stringify(this.props.orders))
    // check if the order must be update
    if (!mustOrderUpdateDueToSocket([data.Id], this.props.orders)) return

    // Some data can't be transferred using sockets, as it can be specific to current user (customer/shop/...), in these cases, client must request data from api.
    if (getFromServer) {
      let filter = {
        // ...this.props.filter, // uncommented because when using a filter with "Approved for invoicing" and then invoicing the order and marking as invoiced, it would not update
        identification: {
          ordernumber: {
            value: data.Id,
            option: 1
          }
        }
      }
      filter.SimpleSearch = this.state.simplesearch === '' ? null : this.state.simplesearch
      // console.log('getOrdersNew in updateSingleOrder', filter, 'initial', this.props.initialFilter)
      this.props.getOrdersNew(filter).then((res) => {
        let steps = res.data[0].Steps
        let foundOrder = null
        let groupIndex
        let itemIndex
        for (let s = 0; s < steps.length; s++) {
          if (steps[s].Orders !== undefined && steps[s].Orders.length > 0) {
            for (let o = 0; o < steps[s].Orders.length; o++) {
              if (steps[s].Orders[o].Id === data.Id) {
                foundOrder = steps[s].Orders[o]
                break
              }
            }
          }
          if (foundOrder !== null) break
        }
        // Set new orders
        for (let i = 0; i < orders.length; i++) {
          let group = orders[i]
          for (let idx = 0; idx < group.Orders.length; idx++) {
            let order = group.Orders[idx]
            if (foundOrder !== null && order.Id === foundOrder.Id) {
              groupIndex = i
              itemIndex = idx
              break
            }
          }
          if (groupIndex !== undefined && itemIndex !== undefined) break
        }
        if (groupIndex !== undefined && itemIndex !== undefined) {
          this.props.updateOrderListSingle(foundOrder, groupIndex, itemIndex)
        }
      })
    } else {
      // Set new orders
      let groupIndex = 0
      let itemIndex = 0
      for (let i = 0; i < orders.length; i++) {
        let group = orders[i]
        for (let idx = 0; idx < group.Orders.length; idx++) {
          let order = group.Orders[idx]
          if (order.Id === data.Id) {
            groupIndex = i
            itemIndex = idx
            break
          }
        }
        if (groupIndex > 0 && itemIndex > 0) break
      }
      this.props.updateOrderListSingle(data, groupIndex, itemIndex)
    }
  }

  updateOrderSteps (data) {
    // console.log('updateOrderSteps', data)
    let filterData = getOrderFilterData(this.props)
    let searchData = { ...filterData.filter } // Ensures orders are updated according to current filter.
    if (data.IsReferredOut === true) {
      searchData.MovedOrders = true
    }
    // searchData.SimpleSearch = this.state.simplesearch === '' ? null : this.state.simplesearch
    searchData.SimpleSearch = filterData.hasSimpleSearch ? filterData.simpleSearch.value : null
    // console.log('updateOrderSteps searchData', searchData)
    this.props.getOrdersNew(searchData)
      .then((res) => {
        let orders = res.data[0].Steps
        this.props.updateOrderList(orders)
      })
  }

  orderMovedUpdateOrderSteps (data) {
    // console.log('orderList orderMovedUpdateOrderSteps', data)
    let steps = [...this.state.orders]
    let selectedMovedFromStep
    let selectedMovedToStep

    const getMappedStep = (step) => {
      let result = step
      let stepToCustomerTitleMapping = {
        1: 1,
        2: 2,
        3: 2,
        4: 2,
        5: 2,
        6: 2,
        7: 2,
        101: 2,
        102: 2,
        103: 2,
        104: 2,
        105: 2,
        8: 3
      }
      if (hasAccess([4], this.props.auth.user.UserType)) {
        result = stepToCustomerTitleMapping[parseInt(step)]
      }
      return result
    }

    const getStepIdentifier = (step) => {
      // When showing list in customer view, StepId in state.orders are 0, so need to detect correct step from title.
      if (hasAccess([4], this.props.auth.user.UserType)) {
        return parseInt(step.Title)
      } else {
        return step.StepId
      }
    }

    steps.map((step) => {
      let mappedFrom = getMappedStep(data.MovedFrom)
      let mappedTo = getMappedStep(data.MovedTo)
      let s = getStepIdentifier(step)
      if (s === mappedTo) {
        selectedMovedToStep = step
      }
      if (s === mappedFrom) {
        selectedMovedFromStep = step
      }
    })

    let orderIds = data.MovedOrderIds !== undefined ? data.MovedOrderIds : [data.MovedOrderId]
    // check if the order must be update
    if (!mustOrderUpdateDueToSocket(orderIds, this.props.orders)) return

    let filter = {
      ...this.props.searchFilter,
      SimpleSearch: this.state.simplesearch === '' ? null : this.state.simplesearch,
      identification: {
        OrderNumbers: orderIds
      }
    }
    if (data.IsReferredOut === true) {
      filter.MovedOrders = true
    }
    // console.log('orderList orderMovedUpdateOrderSteps', filter)
    let stepsUpdated = false
    this.props.getOrdersNew(filter).then((res) => {
      let searchSteps = res.data[0].Steps
      for (let i = 0; i < orderIds.length; i++) {
        let orderId = orderIds[i]
        let foundOrder = null
        for (let s = 0; s < searchSteps.length; s++) {
          if (searchSteps[s].Orders !== undefined && searchSteps[s].Orders.length > 0) {
            for (let o = 0; o < searchSteps[s].Orders.length; o++) {
              if (searchSteps[s].Orders[o].Id === orderId) {
                foundOrder = searchSteps[s].Orders[o]
                break
              }
            }
          }
          if (foundOrder !== null) break
        }

        if (selectedMovedFromStep !== undefined) {
          // Remove order in 'moved from' step
          let indexInFrom = selectedMovedFromStep.Orders.findIndex(order => order.OrderKey === orderId + '')
          if (indexInFrom >= 0) {
            selectedMovedFromStep.Orders.splice(indexInFrom, 1)
            stepsUpdated = true
          } else {
            // Didn't find order in suggested moved-from step.
            // Look in other special steps with stepId 0 (draft is included here, but doesn't matter - this is to cover moved orders)
            var fromSteps = steps.filter(x => x.StepId === 0)
            for (let s = 0; s < fromSteps.length; s++) {
              indexInFrom = fromSteps[s].Orders.findIndex(order => order.OrderKey === orderId + '')
              if (indexInFrom >= 0) {
                fromSteps[s].Orders.splice(indexInFrom, 1)
                stepsUpdated = true
                break
              }
            }
          }
        }
        if (foundOrder !== null) {
          // Insert order in 'moved to' step (remove first if already inserted)
          if (selectedMovedToStep !== undefined) {
            let indexInTo = selectedMovedToStep.Orders.findIndex(order => order.Id === foundOrder.Id)
            let doInsert = true
            if (indexInTo >= 0) {
              doInsert = false
              let orderInTo = selectedMovedToStep.Orders[indexInTo]
              if (!foundOrder.IsDisplayOnly || orderInTo.IsDisplayOnly) { // If exists in step, only replace if old is displayOnly or new is not displayOnly
                selectedMovedToStep.Orders.splice(indexInTo, 1)
                doInsert = true
              }
            }
            if (doInsert) {
              selectedMovedToStep.Orders.push(foundOrder)
              foundOrder.mathRandom = Math.random()
              stepsUpdated = true
            }
          }
        }

        // if (foundOrder !== null && selectedMovedToStep !== undefined) {
        //   // Insert order in 'moved to' step (remove first if already inserted)
        //   selectedMovedToStep.Orders.push(foundOrder)
        //   foundOrder.mathRandom = Math.random()
        //   stepsUpdated = true
        // }
      }

      if (stepsUpdated) {
        if (selectedMovedToStep !== undefined) {
          let toStepOrderIds = selectedMovedToStep.Orders.map(o => o.Id)
          let step = getStepIdentifier(selectedMovedToStep)
          this.props.getOrderSorting(step, toStepOrderIds).then((res) => {
            selectedMovedToStep.Orders.sort((orderA, orderB) => {
              return res.data.findIndex(id => id === orderA.Id) - res.data.findIndex(id => id === orderB.Id)
            })
            this.props.updateOrderList(steps)
          })
        } else {
          this.props.updateOrderList(steps)
        }
      }
    })
  }

  handleRowUpdate (event) {
    let data = event.data
    let orders = [...this.props.orders]
    orders.map((val, key) => {
      if (val.Title === data.Title) {
        orders[key] = data
      }
    })
    // console.log('orderList handleRowUpdate', orders, event)
    orders[event.pos].Orders.splice(event.index, 1)
    this.props.updateOrderList(orders)
  }

  handleLinkedOrders () {
    // console.log('orderList handleLinkedOrders', this.props.filter, this.props.auth.user.UserType)
    let filterData = getOrderFilterData(this.props)
    let thisFilter = filterData.hasSimpleSearch ? filterData.simpleSearch : filterData.filter
    // this.props.getOrdersAdvanced(this.props.filter, this.props.auth.user.UserType)
    this.props.getOrdersAdvanced(thisFilter, this.props.auth.user.UserType)
  }

  getOrders (filter) {
    if (!isEqual(this.props.orders, this.state.orders) || this.state.orders.length === 0) {
      if (!this.state.isLoading) {
        this.setState({
          isLoading: true,
          filterOpen: false
        }, () => {
          // console.log('Call getOrdersAdvanced', filter)
          this.props.getOrdersAdvanced(filter, this.props.auth.user.UserType)
        })
      }
    }
  }

  componentWillReceiveProps (props) {
    this.setState({
      isLoading: false,
      orders: props.orders
    })
  }

  showAddPopup () {
    this.props.triggerPopup(!this.state.addPopupShow)
    this.setState({
      addPopupShow: !this.state.addPopupShow
    })
  }

  openFilter () {
    this.setState({
      filterOpen: !this.state.filterOpen
    }, () => {
      if (this.state.filterOpen) {
        this.refs.SearchFilter.getWrappedInstance().refs.simplesearch.refs.input.focus()
      }
    })
  }

  headerButtonsRight () {
    const renderSearchButton = () => {
      // Check if search is active
      let filterActive = false
      let simplesearch = ''
      if (this.refs.SearchFilter !== undefined) {
        let instance = this.refs.SearchFilter.getWrappedInstance()
        if (instance.state !== undefined && instance.state.simplesearch !== undefined && instance.state.simplesearch !== null) {
          simplesearch = instance.state.simplesearch.value
        }
      }
      // let simplesearch = this.refs.SearchFilter !== undefined ? this.refs.SearchFilter.getWrappedInstance().state.simplesearch.value : ''
      if (simplesearch === '') {
        let storedSimpleSearch = JSON.parse(window.localStorage.getItem('simpleSearch'))
        if (storedSimpleSearch !== null && storedSimpleSearch.value !== undefined && storedSimpleSearch.value.length > 0) {
          simplesearch = storedSimpleSearch.value
        }
      }
      if (this.refs.SearchFilter !== undefined && isFilterChanged(this.props.auth, simplesearch, this.refs.SearchFilter.getWrappedInstance().props.filter, this.refs.SearchFilter.getWrappedInstance().props.initialFilter)) {
        filterActive = true
      } else {
        let storedFilter = JSON.parse(window.localStorage.getItem('filterOrderlist'))
        if (hasAccess([4], this.props.auth.user.UserType)) {
          storedFilter = JSON.parse(window.localStorage.getItem('filterCustomer'))
        } else if (hasAccess([6], this.props.auth.user.UserType)) {
          storedFilter = JSON.parse(window.localStorage.getItem('filterWP'))
        }
        if (isFilterChanged(this.props.auth, simplesearch, storedFilter, this.props.initialFilter)) { // if page refresh
          filterActive = true
        }
      }

      return (
        <div className={filterActive ? 'searchicon filter-active' : 'searchicon'}>
          <Icon icon={FilterIcons.Magnifier_Black} injectSvg onClick={this.openFilter} ariaText={translation('2048')} />
        </div>
      )
    }

    const renderCreateButton = () => {
      if (!hasAccess([6], this.props.auth.user.UserType) && hasSubscriptionPermission(this.props.auth, 0, 2)) {
        return <div><Button id='btn-createorder' spacing={0} size='m' style='cta' labelText={translation(21)} onClick={this.showAddPopup} /></div>
      }
      return null
    }

    const renderOverviewStatusSelection = () => {
      if (hasSubscriptionPermission(this.props.auth, 30) && !hasAccess([4, 6], this.props.auth.user.UserType)) {
        return (
          <OverviewStatusSelection />
        )
      }
    }

    const renderCapacityOverview = () => {
      if (!hasAccess([5, 7, 3], this.props.auth.user.UserType) || !hasSubscriptionPermission(this.props.auth, 30) || this.props.auth.departmentType !== 1) return null
      return (
        <div className='capacity-overview hide-from-resposive'>
          <Button spacing={0} size='m' style='link' labelText={translation('17912')} onClick={() => this.props.openOverlay('OrderCapacityOverview')} />
        </div>
      )
    }

    // let createButton = !hasAccess([6], this.props.auth.user.UserType) && hasSubscriptionPermission(this.props.auth, 0, 2) ? <div className='hint--left' aria-label={translation('21')}><img src='/images/icons/circle_plus22-black.png' onClick={this.showAddPopup} className='icon' /></div> : ''
    let isBodyShop = this.props.auth.departmentType === 1 || this.props.auth.departmentType === 2

    return (
      <div>
        <div className='alignHelper' />
        {renderCapacityOverview()}
        {renderOverviewStatusSelection()}
        {renderSearchButton()}
        {renderCreateButton()}
        <NewOrdersModal router={this.props.router}
          show={this.state.addPopupShow}
          onClose={this.showAddPopup}
          bodyShop={isBodyShop} />

        <OrderCapacityOverview />
      </div>
    )
  }

  quickSearch (val) {
    this.setState({
      isLoading: true,
      filterOpen: false,
      simplesearch: val
    })
    this.props.setOrdersSearch(true)
    this.props.getOrdersAdvanced({
      SimpleSearch: val,
      SkipCheck: true,
      MovedOrders: true
    }, this.props.auth.user.UserType)
    this.refs.list.getWrappedInstance().setSimpleSearch(val)
    this.refs.list.getWrappedInstance().resetPagination()
  }

  onSearchSubmit (filter) {
    // console.log('onSearchSubmit', filter)
    if (!this.state.isLoading) { // fix double search when logging out and in
      this.setState({
        isLoading: true,
        filterOpen: false,
        simplesearch: null
      }, () => {
        this.props.setOrdersSearch(true)
        this.props.getOrdersAdvanced(filter, this.props.auth.user.UserType)
      })
    }
    if (this.refs.list !== undefined) {
      this.refs.list.getWrappedInstance().setSimpleSearch(null)
      this.refs.list.getWrappedInstance().resetPagination()
    }
  }

  infoModal () {
    const closeInfoModal = () => {
      this.props.triggerPopup(false)
      this.props.setInfoModal(false)
    }
    return (
      <InfoModal show={this.props.infoPopup} onClose={closeInfoModal}>
        {this.props.infoPopup}
      </InfoModal>
    )
  }

  closeLoginAs (update, data) {
    this.setState({
      loginasmodal: false,
      loginasmodalData: {}
    }, () => {
      // if (this.state.reloadAfterModalClose) {
      //   this.setState({ reloadAfterModalClose: false }, () => {
      //     console.log('Calling getOrders with initialFilter', this.props.initialFilter)
      //     this.props.getOrdersAdvanced(this.props.initialFilter, this.props.auth.user.UserType)
      //   })
      // }

      if (data === undefined) {
        return
      }

      this.setState({
        isLoading: true,
        simplesearch: null
      })

      let filterData = getOrderFilterData(this.props)
      let thisFilter = filterData.hasSimpleSearch ? filterData.simpleSearch : filterData.filter

      this.props.getOrdersAdvanced(thisFilter, this.props.auth.user.UserType).then(() => {
        this.setState({isLoading: false})
        if (typeof update === 'boolean' && update) {
          if (typeof data !== 'undefined') {
            if (typeof data.type !== 'undefined') {
              // Stop/start - START
              if (data.type === 'stop' || data.type === 'start') {
                this.setState({
                  openStartStopId: data.id
                }, () => {
                  let updateData = {
                    Id: data.id,
                    IsUpdateRequired: true
                  }
                  this.updateSingleOrder(updateData)
                })
              }
              // Stop/start - END
              // Action - START
              if (data.type === 'action') {
                this.setState({
                  openAction: data.id
                }, () => {
                  setTimeout(() => {
                  }, 5000)
                })
              }
              // Action - END
              // Move - START
              if (data.type === 'move') {
                if (data.isOneStepMove) {
                  this.initiateMove(data.move.el, data.move.target, data.move.source, data.move.sibling, data.item)
                  return null
                }
                this.props.moveOrder(data.move).then((res) => {
                  if (res.data.MoveFailed) {
                    this.props.triggerPopup(true)
                    let quality = data.quality
                    quality.data = res.data
                    this.setState({
                      quality: quality
                    })
                  } else {
                    if (this.stepHasComments(res.data)) {
                      this.props.triggerPopup(true)
                      let quality = data.quality
                      quality.data = res.data
                      this.setState({
                        quality: quality
                      })
                    }
                    if (data.move.CheckOnly) {
                      let item = data.item
                      item.NewStepId = parseInt(data.stepid)
                      item.StepIndex = data.pos1
                      item.ItemIndex = data.index
                      // Difference
                      const difference = (a, b) => {
                        return Math.abs(a - b)
                      }
                      let type = (data.pos1 > data.pos2) ? 1 : 2
                      if (difference(data.pos1, data.pos2) === 1) {
                        type = 1
                      }
                      this.setState({
                        moveItem: {
                          open: true,
                          type: type,
                          item: item
                        }
                      })
                      this.props.triggerPopup(true)
                    } else {
                      this.updateRow(res.data.CurrentStepOrders, data.pos1, data.index)
                    }
                  }
                }, (res) => {
                  // Toastr
                  let message
                  if (res.response.data.IsStopped === true) message = translation('12347')
                  else if (res.response.data.IsReffered === true) message = translation('2704')
                  else message = translation('1731')
                  window.toastr.error(message, translation('216'))
                })
              } // Move - END
              // NEW ORDER - START
              if (data.type === 'neworder') {
                this.showAddPopup()
              }
            } // Typeof data.type - END
          } // Typeof data - END
        }
      })
    })
    this.props.triggerPopup(false)
  }

  render () {
    // let VisibilitySensor = require('react-visibility-sensor')
    let extraClass = ''
    if (this.state.filterOpen) {
      extraClass += 'open'
    }

    let openAction = false

    const hasOpendStatrStop = () => {
      this.setState({
        openStartStopId: false
      })
    }

    return (
      <div className='orderlist__screen clearfix'>
        <Header router={this.props.router} renderRight={this.headerButtonsRight} changeTrigger={Math.random()} />
        {this.infoModal()}

        <div className={'filter__wrap clearfix ' + extraClass}>
          <div className='right__filter__wrap'>
            <SearchFilter router={this.props.router} ref='SearchFilter' onSubmit={this.onSearchSubmit} onSimple={this.quickSearch} source='orderlist' />
          </div>
          <div className='right__wrap'>
            <List
              router={this.props.router}
              ref='list'
              orders={this.state.orders}
              isLoading={this.props.isSearching}
              errors={this.props.orderErrors}
              onStartAsShopLogin={this.onStartAsShopLogin}
              moveOrders={this.moveOrders}  // Den findes ikke (??)
              // openStartStop={openStartStop}
              hasOpendStatrStop={hasOpendStatrStop}
              // setSelectedItem={setSelectedItem.bind(this)}
              openAction={openAction}
              openStartStopId={this.state.openStartStopId}
            />
          </div>
        </div>
        {hasAccess([5, 7], this.props.auth.user.UserType) && this.state.loginasmodal && (
          <LoginAsModal router={this.props.router}
            data={this.state.loginasmodalData}
            show={this.state.loginasmodal}
            onClose={this.closeLoginAs} />
        )}
      </div>
    )
  }

}

OrderList.propTypes = {
  auth: PropTypes.object.isRequired,
  getOrdersAdvanced: PropTypes.func.isRequired,
  triggerPopup: PropTypes.func.isRequired,
  setInfoModal: PropTypes.func.isRequired
}

function mapStateToProps (state) {
  // state.orders.filter.movedOrders = true
  // state.orders.initialFilter.movedOrders = true
  let initialFilter = state.orders.initialFilterOrderlist
  let filter = state.orders.filterOrderlist
  if (hasAccess([4], state.auth.user.UserType)) {
    initialFilter = state.orders.initialFilterCustomer
    filter = state.orders.filterCustomer
  } else if (hasAccess([6], state.auth.user.UserType)) {
    initialFilter = state.orders.initialFilterWP
    filter = state.orders.filterWP
  }
  return {
    auth: state.auth,
    orders: state.orders.orders,
    filter: filter,
    initialFilter: initialFilter,
    orderErrors: state.orders.errors,
    infoPopup: state.backdrop.infoPopup,
    activeEmployees: state.assign.activeEmployees,
    isSearching: state.orders.isSearching
  }
}

export default connect(mapStateToProps, {
  getOrdersNew,
  getOrdersAdvanced,
  getOrderSimple,
  triggerPopup,
  setInfoModal,
  updateOrderList,
  updateOrderListSingle,
  getOrderDataNew,
  isFilterChanged,
  setOrdersSearch,
  setOrdersFilter,
  getOrderSorting,
  resetFilter,
  resetSimplesearch,
  openPopup,
  closePopup,
  openOverlay
})(OrderList)



// WEBPACK FOOTER //
// ./src/app/pages/Orders/OrderList/index.js